import React, {FC} from 'react';

import s from './subscribeBenefits.scss';

const BENEFITS = [
    {
        description:
            'We’ll ship you new contacts as often as\nyou need, so you’re always stocked up.',
        icon: s.recharge,
        id: 1,
    },
    {
        description: 'Get 15% off all your future orders,\nwith free shipping.',
        icon: s.discount,
        id: 2,
    },
    {
        description: 'Modify or cancel your subscription\nanytime, no strings attached.',
        icon: s.pause,
        id: 3,
    },
    {
        description: 'Get FREE prescription glasses worth up\nto $150 with your first order.',
        icon: s.glasses,
        id: 4,
    },
];

/**
 * Component with the subscribe benefits explanation
 * @returns {React.ReactElement} - component
 */
export const SubscribeBenefits: FC = () => (
    <>
        {BENEFITS.map(({description, icon, id}) => (
            <div className={s.benefit} key={id}>
                <div className={icon} />
                <p className={s.description}>{description}</p>
            </div>
        ))}
    </>
);
